export default __webpack_public_path__ + "static/media/hazz.25e9a086.jpg";